<template>
  <div class="dados">
    <div class="row m-0">
      <div class="col-12">
        <h1 class="font-weight-bold text-uppercase">Meus Dados</h1>
        <hr class="linha-amarela" />

        <div class="row mb-3">
          <div class="col-12">
            <div class="planos p-t-0">
              <Plan1
                v-if="this.dadosUsuario.informacoes.plano.plano_id == 1"
                contractId="contrato-representante-plano-1"
              />
              <Plan2
                v-if="this.dadosUsuario.informacoes.plano.plano_id == 2"
                contractId="contrato-representante-plano-2"
              />
              <p class="fs-12">
                *Caso queira mudar de plano entre em contato com a equipe Constr
                Up
              </p>
            </div>
          </div>
        </div>

        <h4 class="text-uppercase">Dados de Acesso</h4>
        <table class="info">
          <tr>
            <th class="titulo">Nome:</th>
            <td class="texto" v-if="dados.email.show === false">
              {{ dadosUsuario.email }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.email.show = !dados.email.show"
              >
                <a class="pointer">Editar</a>
              </b>
            </td>
            <td class="texto" v-if="dados.email.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.email.value"
                :placeholder="dados.email.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.email.show = !dados.email.show"
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
          <tr>
            <th class="titulo">Senha:</th>
            <td class="texto" v-if="dados.senha.show === false">
              ********
              <b
                class="btn-modificar letter-orange"
                @click="dados.senha.show = !dados.senha.show"
              >
                <a class="pointer">Editar</a>
              </b>
            </td>
            <td class="texto" v-if="dados.senha.show === true">
              <input
                type="password"
                class="edit-text"
                v-model="dados.senha.value"
                placeholder="******"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.senha.show = !dados.senha.show"
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
        </table>

        <hr class="linha-cinza" />
        <h4 class="text-uppercase">Dados da Conta</h4>
        <table class="info">
          <tr>
            <th class="titulo">Razão Social:</th>
            <td class="texto" v-if="dados.razao_social.show === false">
              {{ dadosUsuario.informacoes.razao_social }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.razao_social.show = !dados.razao_social.show"
              >
                <a class="pointer">Editar</a>
              </b>
            </td>
            <td class="texto" v-if="dados.razao_social.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.razao_social.value"
                :placeholder="dados.razao_social.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.razao_social.show = !dados.razao_social.show"
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
          <tr>
            <th class="titulo">Nome Fantasia:</th>
            <td class="texto" v-if="dados.nome_fantasia.show === false">
              {{ dadosUsuario.informacoes.nome_fantasia }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.nome_fantasia.show = !dados.nome_fantasia.show"
              >
                <a class="pointer">Editar</a>
              </b>
            </td>
            <td class="texto" v-if="dados.nome_fantasia.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.nome_fantasia.value"
                :placeholder="dados.nome_fantasia.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.nome_fantasia.show = !dados.nome_fantasia.show"
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
          <tr>
            <th class="titulo">Responsável:</th>
            <td class="texto" v-if="dados.nome_responsavel.show === false">
              {{ dadosUsuario.informacoes.nome_responsavel }}
              <b
                class="btn-modificar letter-orange"
                @click="
                  dados.nome_responsavel.show = !dados.nome_responsavel.show
                "
              >
                <a class="pointer">Editar</a>
              </b>
            </td>
            <td class="texto" v-if="dados.nome_responsavel.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.nome_responsavel.value"
                :placeholder="dados.nome_responsavel.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="
                  dados.nome_responsavel.show = !dados.nome_responsavel.show
                "
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
          <tr>
            <th class="titulo">CNPJ:</th>
            <td class="texto" v-if="dados.cnpj.show === false">
              {{ dadosUsuario.cnpj }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.cnpj.show = !dados.cnpj.show"
              >
                <a class="pointer">Editar</a>
              </b>
            </td>
            <td class="texto" v-if="dados.cnpj.show === true">
              <input
                type="text"
                class="edit-text"
                v-mask="'##.###.###/####-##'"
                v-model="dados.cnpj.value"
                :placeholder="dados.cnpj.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.cnpj.show = !dados.cnpj.show"
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
          <tr>
            <th class="titulo">Whatsapp:</th>
            <td class="texto" v-if="dados.celular.show === false">
              {{ dadosUsuario.informacoes.celular }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.celular.show = !dados.celular.show"
              >
                <a class="pointer">Editar</a>
              </b>
            </td>
            <td class="texto" v-if="dados.celular.show === true">
              <input
                type="text"
                class="edit-text"
                v-mask="['(##) #####-####', '(##) ####-####']"
                v-model="dados.celular.value"
                :placeholder="dados.celular.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.celular.show = !dados.celular.show"
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
          <tr>
            <th class="titulo">Telefone:</th>
            <td class="texto" v-if="dados.telefone.show === false">
              {{ dadosUsuario.informacoes.telefone }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.telefone.show = !dados.telefone.show"
              >
                <a class="pointer">Editar</a>
              </b>
            </td>
            <td class="texto" v-if="dados.telefone.show === true">
              <input
                type="text"
                class="edit-text"
                v-mask="'(##) ####-####'"
                v-model="dados.telefone.value"
                :placeholder="dados.telefone.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.telefone.show = !dados.telefone.show"
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
          <tr>
            <th class="titulo">Telefone2:</th>
            <td class="texto" v-if="dados.telefone2.show === false">
              {{ dadosUsuario.informacoes.telefone2 }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.telefone2.show = !dados.telefone2.show"
              >
                <a class="pointer">Editar</a>
              </b>
            </td>
            <td class="texto" v-if="dados.telefone2.show === true">
              <input
                type="text"
                class="edit-text"
                v-mask="'(##) ####-####'"
                v-model="dados.telefone2.value"
                :placeholder="dados.telefone2.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.telefone2.show = !dados.telefone2.show"
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
        </table>

        <hr class="linha-cinza" />
        <h4 class="text-uppercase">Endereço</h4>
        <table class="info">
          <tr>
            <th class="titulo"></th>
            <td class="texto">
              <span v-if="dados.endereco.show === false">{{
                dadosUsuario.informacoes.endereco
              }}</span>
              <span v-else>
                <input
                  type="text"
                  v-model="dados.endereco.value"
                  class="d-inline-block w-150px edit-text"
                  :placeholder="dadosUsuario.informacoes.endereco"
                /> </span
              >,
              <span v-if="dados.numero.show === false">{{
                dadosUsuario.informacoes.numero
              }}</span>
              <span v-else>
                <input
                  type="text"
                  v-model="dados.numero.value"
                  class="d-inline-block w-50px edit-text"
                  :placeholder="dadosUsuario.informacoes.numero"
                />
              </span>
              <b
                class="btn-modificar letter-orange"
                v-if="dados.modificarEndNumShow !== true"
                @click="modificarEndNum()"
              >
                <a class="pointer">Editar</a>
              </b>
              <b
                class="btn-modificar letter-orange"
                v-else
                @click="modificarEndNum()"
              >
                <a class="pointer">Voltar</a>
              </b>
              <br />
              <span v-if="dados.bairro.show === false">{{
                dadosUsuario.informacoes.bairro
              }}</span>
              <span v-else>
                <input
                  type="text"
                  v-model="dados.bairro.value"
                  class="d-inline-block w-100 edit-text"
                  :placeholder="dadosUsuario.informacoes.bairro"
                />
              </span>
              -
              <span v-if="dados.cidade.show === false">
                <label
                  class="m-0"
                  v-if="dadosUsuario.informacoes.cidade !== null"
                  >{{ dadosUsuario.informacoes.cidade.nome }}</label
                >
              </span>
              <span v-else>
                <v-select
                  class="d-inline-block"
                  v-model="dados.cidade.value"
                  label="nome"
                  :options="cidades"
                >
                  <div slot="no-options">Não encontrou nada.</div>
                </v-select>
              </span>
              /
              <span v-if="dados.estado.show === false">
                <label
                  class="m-0"
                  v-if="dadosUsuario.informacoes.estado !== null"
                  >{{ dadosUsuario.informacoes.estado.uf }}</label
                >
              </span>
              <span v-else>
                <v-select
                  class="d-inline-block"
                  v-model="dados.estado.value"
                  label="uf"
                  :options="estados"
                >
                  <div slot="no-options">Não encontrou nada.</div>
                </v-select>
              </span>
              <b
                class="btn-modificar letter-orange"
                v-if="dados.modificarBaiCidEstShow !== true"
                @click="modificarBaiCidEst()"
              >
                <a class="pointer">Editar</a>
              </b>
              <b
                class="btn-modificar letter-orange"
                v-else
                @click="modificarBaiCidEst()"
              >
                <a class="pointer">Voltar</a>
              </b>
              <br />
              <span v-if="dados.cep.show === false"
                >CEP: {{ dadosUsuario.informacoes.cep }}</span
              >
              <span v-else>
                <input
                  type="text"
                  v-mask="'##.###-###'"
                  v-model="dados.cep.value"
                  class="d-inline-block w-100px edit-text"
                  :placeholder="dadosUsuario.informacoes.cep"
                />
              </span>
              <b
                class="btn-modificar letter-orange"
                v-if="dados.cep.show !== true"
                @click="dados.cep.show = !dados.cep.show"
              >
                <a class="pointer">Editar</a>
              </b>
              <b
                class="btn-modificar letter-orange"
                v-else
                @click="dados.cep.show = !dados.cep.show"
              >
                <a class="pointer">Voltar</a>
              </b>
              <br />
              <span v-if="dados.complemento.show === false"
                >Complemento: {{ dadosUsuario.informacoes.complemento }}</span
              >
              <span v-else>
                <input
                  type="text"
                  v-model="dados.complemento.value"
                  class="d-inline-block w-100px edit-text"
                  :placeholder="dadosUsuario.informacoes.complemento"
                />
              </span>
              <b
                class="btn-modificar letter-orange"
                v-if="dados.complemento.show !== true"
                @click="dados.complemento.show = !dados.complemento.show"
              >
                <a class="pointer">Editar</a>
              </b>
              <b
                class="btn-modificar letter-orange"
                v-else
                @click="dados.complemento.show = !dados.complemento.show"
              >
                <a class="pointer">Voltar</a>
              </b>
            </td>
          </tr>
        </table>
        <div class="field-atualizar text-right m-b-30">
          <div
            class="btn btn-success"
            v-if="verificaEdicao()"
            @click="editarRepresentante()"
          >
            Salvar
          </div>
        </div>

        <hr class="linha-cinza" />
        <h4 class="text-uppercase">Segmentos</h4>
        <table class="info">
          <tr>
            <td class="texto">
              <div
                class="row m-0"
                v-if="segmentosUsuario !== null || segmentosUsuario !== []"
              >
                <div
                  class="col-6 p-0"
                  v-for="(segmento, index) in segmentosUsuario"
                  :key="index"
                >
                  <div class="btn-remove" @click="excluirSegmentos(index)">
                    <i class="fas fa-times"></i>
                  </div>
                  <v-select
                    class="seg-alt p-right-10px"
                    v-model="segmento.segmento"
                    label="nome"
                    :options="segmentos"
                    placeholder="Digite um segmento"
                  ></v-select>
                </div>
              </div>
              <div
                class="fs-12 btn btn-add-trab text-uppercase"
                @click="adicionarSegmentos()"
              >
                Adicionar
              </div>
              <div
                class="fs-12 btn btn-atualizar text-uppercase"
                @click="salvarSegmentos()"
              >
                Salvar
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- Contrato Representante Plano 1 -->
    <RepresentativeContractPlan1
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 1"
    />
    <!-- Contrato Representante Plano 2 -->
    <RepresentativeContractPlan2
      v-if="this.dadosUsuario.informacoes.plano.plano_id === 2"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters } from 'vuex';
import { CoolSelect } from 'vue-cool-select';
import Plan1 from '../../components/Plan1';
import Plan2 from '../../components/Plan2';
import RepresentativeContractPlan1 from '../../components/RepresentativeContractPlan1';
import RepresentativeContractPlan2 from '../../components/RepresentativeContractPlan2';

export default {
  name: 'dados',
  components: {
    CoolSelect,
    Plan1,
    Plan2,
    RepresentativeContractPlan1,
    RepresentativeContractPlan2,
  },
  data: () => ({
    dados: {
      email: {
        value: null,
        placeholder: null,
        show: false,
      },
      senha: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome_usuario: {
        value: null,
        placeholder: null,
        show: false,
      },
      razao_social: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome_fantasia: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome_responsavel: {
        value: null,
        placeholder: null,
        show: false,
      },
      cnpj: {
        value: null,
        placeholder: null,
        show: false,
      },
      celular: {
        value: null,
        placeholder: null,
        show: false,
      },
      telefone: {
        value: null,
        placeholder: null,
        show: false,
      },
      telefone2: {
        value: null,
        placeholder: null,
        show: false,
      },
      endereco: {
        value: null,
        placeholder: null,
        show: false,
      },
      complemento: {
        value: null,
        placeholder: null,
        show: false,
      },
      numero: {
        value: null,
        placeholder: null,
        show: false,
      },
      bairro: {
        value: null,
        placeholder: null,
        show: false,
      },
      cidade: {
        value: null,
        placeholder: null,
        show: false,
      },
      estado: {
        value: null,
        placeholder: null,
        show: false,
      },
      cep: {
        value: null,
        placeholder: null,
        show: false,
      },
      modificarEndNumShow: false,
      modificarBaiCidEstShow: false,
    },
  }),
  computed: {
    ...mapState({
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      estados: (state) => state.estados,
      cidades: (state) => state.cidades,
      segmentos: (state) => state.segmentos,
      segmentosUsuario: (state) => state.dadosUsuario.informacoes.segmentos,
    }),
    ...mapGetters(['getTipoNotification', 'getNotification']),
  },
  created() {
    // console.log(this.dados);
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadEstados');
    this.$store.dispatch('loadSegmentos');
  },
  beforeMount() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'area-restrita' });
    }
    this.dados.email.placeholder = this.dadosUsuario.email;
    this.dados.nome_usuario.placeholder = this.dadosUsuario.nome_usuario;
    this.dados.razao_social.placeholder =
      this.dadosUsuario.informacoes.razao_social;
    this.dados.nome_fantasia.placeholder =
      this.dadosUsuario.informacoes.nome_fantasia;
    this.dados.nome_responsavel.placeholder =
      this.dadosUsuario.informacoes.nome_responsavel;
    this.dados.cnpj.placeholder = this.dadosUsuario.cnpj;
    this.dados.celular.placeholder = this.dadosUsuario.informacoes.celular;
    this.dados.telefone.placeholder = this.dadosUsuario.informacoes.telefone;
    this.dados.telefone2.placeholder = this.dadosUsuario.informacoes.telefone2;
    this.dados.endereco.placeholder = this.dadosUsuario.informacoes.endereco;
    this.dados.complemento.placeholder =
      this.dadosUsuario.informacoes.complemento;
    this.dados.numero.placeholder = this.dadosUsuario.informacoes.numero;
    this.dados.bairro.placeholder = this.dadosUsuario.informacoes.bairro;
    if (this.dadosUsuario.informacoes.cidade !== null) {
      this.dados.cidade.placeholder = this.dadosUsuario.informacoes.cidade.nome;
    }
    if (this.dadosUsuario.informacoes.estado !== null) {
      this.dados.estado.placeholder = this.dadosUsuario.informacoes.estado.uf;
    }
    this.dados.cep.placeholder = this.dadosUsuario.informacoes.cep;

    this.dados.email.value = this.dadosUsuario.email;
    this.dados.nome_usuario.value = this.dadosUsuario.nome_usuario;
    this.dados.razao_social.value = this.dadosUsuario.informacoes.razao_social;
    this.dados.nome_fantasia.value =
      this.dadosUsuario.informacoes.nome_fantasia;
    this.dados.nome_responsavel.value =
      this.dadosUsuario.informacoes.nome_responsavel;
    this.dados.cnpj.value = this.dadosUsuario.cnpj;
    this.dados.celular.value = this.dadosUsuario.informacoes.celular;
    this.dados.telefone.value = this.dadosUsuario.informacoes.telefone;
    this.dados.telefone2.value = this.dadosUsuario.informacoes.telefone2;
    this.dados.endereco.value = this.dadosUsuario.informacoes.endereco;
    this.dados.complemento.value = this.dadosUsuario.informacoes.complemento;
    this.dados.numero.value = this.dadosUsuario.informacoes.numero;
    this.dados.bairro.value = this.dadosUsuario.informacoes.bairro;
    this.dados.cidade.value = this.dadosUsuario.informacoes.cidade;
    this.dados.estado.value = this.dadosUsuario.informacoes.estado;
    this.dados.cep.value = this.dadosUsuario.informacoes.cep;
  },
  beforeUpdate() {
    if (this.$router.history.current.name === 'cadastro') {
      if (this.checkIsEmpty(this.token)) {
        this.$router.push({ name: 'area-restrita' });
      }
    }
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    modificarEndNum() {
      this.dados.endereco.show = !this.dados.endereco.show;
      this.dados.numero.show = !this.dados.numero.show;
      this.dados.modificarEndNumShow = !this.dados.modificarEndNumShow;
    },
    modificarBaiCidEst() {
      this.dados.bairro.show = !this.dados.bairro.show;
      this.dados.cidade.show = !this.dados.cidade.show;
      this.dados.estado.show = !this.dados.estado.show;
      this.dados.modificarBaiCidEstShow = !this.dados.modificarBaiCidEstShow;
    },
    verificaEdicao() {
      if (
        this.dados.email.show !== false ||
        this.dados.senha.show !== false ||
        this.dados.nome_usuario.show !== false ||
        this.dados.razao_social.show !== false ||
        this.dados.nome_fantasia.show !== false ||
        this.dados.nome_responsavel.show !== false ||
        this.dados.cnpj.show !== false ||
        this.dados.celular.show !== false ||
        this.dados.telefone.show !== false ||
        this.dados.telefone2.show !== false ||
        this.dados.endereco.show !== false ||
        this.dados.complemento.show !== false ||
        this.dados.numero.show !== false ||
        this.dados.bairro.show !== false ||
        this.dados.cidade.show !== false ||
        this.dados.estado.show !== false ||
        this.dados.cep.show !== false
      ) {
        return true;
      }
      return false;
    },
    editarRepresentante() {
      const self = this;
      const data = {
        id: this.dadosUsuario.id,
        id_representante: this.dadosUsuario.informacoes.id,
      };

      Object.assign(data, { email: this.dados.email.value });
      Object.assign(data, { razao_social: this.dados.razao_social.value });
      Object.assign(data, { nome_fantasia: this.dados.nome_fantasia.value });
      Object.assign(data, {
        nome_responsavel: this.dados.nome_responsavel.value,
      });
      Object.assign(data, { cnpj: this.dados.cnpj.value });
      Object.assign(data, { celular: this.dados.celular.value });
      Object.assign(data, { telefone: this.dados.telefone.value });
      Object.assign(data, { telefone2: this.dados.telefone2.value });
      Object.assign(data, { endereco: this.dados.endereco.value });
      Object.assign(data, { complemento: this.dados.complemento.value });
      Object.assign(data, { numero: this.dados.numero.value });
      Object.assign(data, { bairro: this.dados.bairro.value });
      Object.assign(data, { cidade: this.dados.cidade.value });
      Object.assign(data, { estado: this.dados.estado.value });
      Object.assign(data, { cep: this.dados.cep.value });

      if (this.dados.senha.value !== null) {
        Object.assign(data, { password: this.dados.senha.value });
      }

      this.$store.dispatch('updateRepresentante', data).then((data) => {
        this.$store.dispatch('startLoader');
        setTimeout(() => {
          if (this.getTipoNotification == 1) {
            this.aviso(this.getNotification, 'success');
            self.dados.email.show = false;
            self.dados.senha.show = false;
            self.dados.nome_usuario.show = false;
            self.dados.razao_social.show = false;
            self.dados.nome_fantasia.show = false;
            self.dados.nome_responsavel.show = false;
            self.dados.cnpj.show = false;
            self.dados.celular.show = false;
            self.dados.telefone.show = false;
            self.dados.telefone2.show = false;
            self.dados.endereco.show = false;
            self.dados.complemento.show = false;
            self.dados.numero.show = false;
            self.dados.bairro.show = false;
            self.dados.cidade.show = false;
            self.dados.estado.show = false;
            self.dados.cep.show = false;
          } else if (this.getTipoNotification == 3) {
            this.aviso(this.getNotification, 'danger');
          }
        }, 1000);
      });
    },
    adicionarSegmentos() {
      this.segmentosUsuario.push({
        segmento: {
          nome: 'Segmento',
        },
      });
    },
    salvarSegmentos() {
      const data = {
        id: this.dadosUsuario.informacoes.id,
        segmentos: this.segmentosUsuario,
      };

      this.$store
        .dispatch('updateSegmentosRepresentante', data)
        .then((data) => {
          this.$store.dispatch('startLoader');
          setTimeout(() => {
            this.$store.dispatch('endLoader');
            if (this.getTipoNotification == 1) {
              this.aviso('Dados atualizados com sucesso!', 'success');
            }
          }, 1000);
        });
    },
    excluirSegmentos(index) {
      this.segmentosUsuario.splice(index, 1);
    },
  },
};
</script>
